import type { V2Capabilities } from './content';

const GROUP_ICONS = ['ph-calendar-check', 'ph-heartbeat', 'ph-credit-card', 'ph-megaphone-simple'];

export function Capabilities({ content }: { content: V2Capabilities }) {
  return (
    <section className="v2-section v2-capabilities">
      <div className="v2-container">
        <div className="v2-section-head">
          <span className="v2-eyebrow" data-reveal>
            {content.eyebrow}
          </span>
          <h2 className="v2-h2" data-reveal data-reveal-delay="0.08">
            {content.title} <em className="v2-serif-accent">{content.accent}</em>
          </h2>
        </div>

        <div className="v2-cap-grid" data-reveal-group>
          {content.groups.map((group, index) => (
            <article className="v2-cap-card" key={group.title}>
              <header>
                <span className="v2-cap-icon">
                  <i className={`ph ${GROUP_ICONS[index] ?? 'ph-squares-four'}`} aria-hidden="true" />
                </span>
                <h3>{group.title}</h3>
              </header>
              <ul className="v2-cap-chips">
                {group.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
              <div className="v2-cap-shot">
                <img src={content.images[index]} alt={group.title} loading="lazy" />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
